<style lang="scss" scoped>
</style>

<template>
    <div>
        <navbar></navbar>
        <router-view></router-view>
    </div>
</template>

<script>
import $ from 'jquery'
import utils from '@/common/utils'
import navbar from "@/components/navbar"
import { mapActions } from 'vuex'
// import { getCurrentSkin } from '@/service/settingService'
import { getSkinList, setSkin, getCurrentSkin } from '@/service/settingService'

export default {
    name: "container",
    components: {
        navbar
    },
    methods: {
        ...mapActions([
            'getUserInfo',
            'getBaseSet',
            'getContact'
        ]),
        setSkin(skin) {
            if (skin.cssName == 'default-skin') return
            $('head').append(`<link class="skin" rel="stylesheet" type="text/css" href="${skin.cssUrl}" />`)
            utils.setLocalStorage('skin', JSON.stringify(skin))
            this.$store.commit('SAVE_SKIN', skin)
        }
    },
    created() {
        this.getUserInfo()
        this.getBaseSet()
        this.getContact()
        
        let skin = utils.getLocalStorage('skin')
        if (skin) {
            this.setSkin(JSON.parse(skin))
        }
        getCurrentSkin().then(skin => {
            this.setSkin(skin)
        })
    }
};
</script>



// WEBPACK FOOTER //
// src/page/mail/container.vue